import { Icon } from 'prensa'
import React from 'react'

const IconTwitter = (props) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256" {...props}>
      <g strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDashoffset="0">
        <g transform="scale(5.33333,5.33333)">
          <path d="M41,6l-31.071,36h-3.714l31.072,-36z" fill="#a8a8a8" fillRule="nonzero"></path>
          <path d="M31.143,41l-23.323,-34h8.957l23.323,34z" fill="transparent" fillRule="evenodd"></path>
          <path d="M15.724,9l20.578,30h-4.106l-20.578,-30h4.106M17.304,6h-11.382l24.694,36h11.382l-24.694,-36z" fill="#a8a8a8" fillRule="nonzero"></path>
        </g>
      </g>
    </Icon>
  )
}

export default IconTwitter

